import React from 'react';
import { connect } from "react-redux";
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { Grid, Button, Typography, TextField, FormControlLabel, Checkbox, CircularProgress, Link } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Lock from "@material-ui/icons/Lock";
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import StripeInput from './StripeInput';
import { withStyles } from "@material-ui/core/styles";
import { bindActionCreators } from "redux";
import { scroller, Element } from 'react-scroll';
import * as PaymentActions from "../../actions/PaymentActions";
import { DeclineCode, ErrorCode, SCROLL_OFFSET, STRIPE_TOKEN, WEBSITE_REDIRECT_URL, SUBSCRIPTION_STATUS, PID } from "../../constants";
import { captureStripePayment, hasUnPaidProducts, hasUnPaidSubscriptions, 
  hasSubscription, hasCustomOfferWithSubscription, hasProducts, getTotalPricesStrArray
} from "../../utils";

const stripePromise = loadStripe(STRIPE_TOKEN);

const styles = (theme) => ({
  stripePayBtn: {
    margin: "10px 0",
    height: "3rem"
  },
  agreesContainer: {
    paddingLeft: "19px !important"
  },
  tcs: {
    padding: "14px"
  },
  TC: {
    listStyleType: "none",
    padding: "0",
    margin: "0"
  },
  ssl: {
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: "9px",
    paddingTop: "0 !important",
    paddingBottom: "20px !important"
  },
  cardLogoContainer: {
    display: "grid",
    gridTemplateColumns: "max-content max-content max-content",
    gridTemplateRows: "max-content",
    gridGap: "25px",
    paddingBottom: "0 !important"
  },
  visaContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  masterContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  expressContainer: {
    display: "grid",
    gridTemplateRows: "max-content",
    placeContent: "center",
    "& img": {
      width: "2.8em",
    }
  },
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": {
      fontSize: "1.2em",
    },
    "& legend": {
      fontSize: "0.78em",
    },
  },
})(TextField);

class StripeCheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      agreeOne: false,
      agreeTwo: false,
      agreeThree: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateCard = this.validateCard.bind(this);
    this.hasAgreed = this.hasAgreed.bind(this);
  }

  componentDidUpdate = (prevProps) => {
    const { step, paymentType } = this.props;
    const { step: prevStep, paymentType: prevPaymentType } = prevProps;

    if(step !== prevStep || paymentType !== prevPaymentType)  {
      this.setState({ agreeOne: false, agreeTwo: false, agreeThree: false });
    }

  }

  handleChange = (event) => {
    if (event.error) this.setState({ error: event.error.message});
    else this.setState({ error: null });
  }

  handleSubmit = async (cardSource) => {
    const { actions, userAccount, cart } = this.props;

    actions.openSnackbar('success', 'Please Wait...');

    try {
      const { id, owner } = cardSource;
      const { _id, leadId } = userAccount;
  
      let pID = ""
      let item = cart[0];
      switch (item.type) {
        case PID.PRODUCT :
          pID = "p_" + item._id;
          break;
        
        case PID.CUSTOM_OFFER :
        pID = "c_" + item._id;
        break;
  
        case PID.PRODUCT_PACKAGE :
        pID = "pp_" + item._id;
        break;
  
        case PID.SUBSCRIPTION_PLAN :
        pID = "s_" + item._id;
        break;
  
        default:
          pID = ""
      }

      const { invoice, subscription, errorCode, decline_code } = await captureStripePayment({ id }, { ...owner, _id, leadId, pID} );

      if (invoice) this.props.updateCartItemsToPaid('single');

      if (subscription && (subscription.status === SUBSCRIPTION_STATUS.ACTIVE)) this.props.updateCartItemsToPaid('subscription');

      if (invoice === false || subscription === false || (subscription && subscription.status === SUBSCRIPTION_STATUS.INCOMPLETE)) {
        switch (errorCode) {
          case ErrorCode.EXPIRED_CARD:
            actions.openSnackbar('error', "Your card has expired.", 60000);
            this.scrollToElement("element-cc-details");
            break;
          
          case ErrorCode.INCORRECT_CVC:
            actions.openSnackbar('error', "Your card's CVC number is incorrect.", 60000);
            this.scrollToElement("element-cc-details");
            break;
          
          case ErrorCode.CARD_DECLINED:
            switch (decline_code) {
              case DeclineCode.GENERIC_DECLINE:
                actions.openSnackbar('error', "Your card has been declined. Please try again or contact your bank if the issue persists.", 60000);
                this.scrollToElement("element-cc-details");
                break;

              case DeclineCode.INSUFFICIENT_FUNDS:
                actions.openSnackbar('error', "Your card has insufficient funds.", 60000);
                this.scrollToElement("element-cc-details");
                break;

              case DeclineCode.TRANSACTION_NOT_ALLOWED:
                actions.openSnackbar('error', "Your card does not support this type of purchase. Please try with another card.", 60000);
                this.scrollToElement("element-cc-details");
                break;

              case DeclineCode.INCORRECT_NUMBER:
                actions.openSnackbar('error', "The card number is incorrect.", 60000);
                this.scrollToElement("element-cc-details");
                break;


              default:
                actions.openSnackbar('error', 'Something went wrong. Please contact us at 03 9018 5438', 60000); 
                this.scrollToElement("element-cc-details");
            }
            break;

          default:
            actions.openSnackbar('error', 'Something went wrong. Please contact us at 03 9018 5438', 60000); 
            this.scrollToElement("element-cc-details");
            break;
        }
      }  
      else {
        window.location = WEBSITE_REDIRECT_URL;
      }
    } catch (error) {
      console.error(error);
      actions.openSnackbar('error', error.message || 'Payment Error');
    } finally {
      actions.setLoading(false);
    }

  }

  hasAgreed = () => {
    const { agreeOne, agreeTwo, agreeThree } = this.state;
    const hasSubs = hasSubscription(this.props.cart) || hasCustomOfferWithSubscription(this.props.cart);
    const hasProd = hasProducts(this.props.cart);

    if (hasSubs && hasProd) return  agreeOne === true && agreeTwo === true && agreeThree === true;
    else if(hasSubs) return  agreeOne === true && agreeThree === true;
    else return agreeOne === true && agreeTwo === true;
  }

  validateCard = async (stripe, elements) => {
    const { actions, cart, userAccount, isConsultingServicesProdValid, coupon, installments, rebate, balance, depositUsed, creditUsed } = this.props;
    const { handleRebatePayment } = this.props;

    if (!this.hasAgreed())
      return actions.openSnackbar('error', 'Please accept the Terms & Conditions');
    
    if (!hasUnPaidSubscriptions(cart) && !hasUnPaidProducts(cart))
      return actions.openSnackbar('warning', 'All items have been paid for');

    const installment = installments.find(({ paid }) => !paid);
    const [ productTotalStr, customOfferSubsTotalStr, subsTotalStr ] = getTotalPricesStrArray(cart, coupon, installment, rebate, balance, depositUsed, creditUsed);

    const { details, email } = userAccount;
    const { fullName, firstName, lastName, contactNumbers } = details;
    const defaultContact = contactNumbers.find(({ isDefault }) => isDefault);

    if (!isConsultingServicesProdValid())
      return actions.openSnackbar('error', 'Invalid quantity in the cart');

    if (productTotalStr === '$0 ' && customOfferSubsTotalStr === '' && subsTotalStr === '' ) {
      handleRebatePayment(true);
    } else {
      actions.setLoading(true);
      const ownerInfo = {
        type: 'card',
        currency: 'aud',
        owner: {
          name: fullName ? fullName : `${firstName} ${lastName}`,
          email,
          phone:defaultContact.number,
        }
      };
  
      if(stripe) {
        try {
          const { error, source  } = await stripe.createSource(elements.getElement(CardCvcElement), ownerInfo);
  
          if (error) {
            this.scrollToElement("element-cc-details");
            this.setState({ error: error.message });
            actions.setLoading(false);
          } else if (source) {
            source.card.billing_email = ownerInfo.owner.email;
  
            this.handleSubmit(source);
          } else {
            actions.openSnackbar('error', 'Something went wrong. Please contact us at 03 9018 5438');
            actions.setLoading(false);
          }
        } catch (error) {
          console.log('validate card: ', error);
          this.scrollToElement("element-cc-details");
          this.setState({ error: error.message });
          actions.setLoading(false);
        }
      } else actions.openSnackbar('error', 'Something went wrong. Please contact us at 03 9018 5438');
    }
    
  }

  scrollToElement = (elementName) => {

    scroller.scrollTo(elementName, {
      duration: 1000,
      delay: 1000,
      smooth: 'easeInOutQuart',
      offset: SCROLL_OFFSET
    });
  }

  renderCardLogos = (pureBalancePayment) => {
    const { classes } = this.props;
    if (pureBalancePayment) return null;
    return (<>
      <div className={classes.visaContainer}>
        <img src="/media/visa.svg" alt="visa-logo"/>
      </div>
      <div className={classes.masterContainer}>
        <img src="/media/master.svg" alt="master-logo"/>
      </div>
      <div className={classes.expressContainer}>
        <img src="/media/amex.svg" alt="express-logo"/>
      </div>
    </>);
  }

  renderCardDetailsForm = () => {
    const { state, props, handleChange } = this;
    const { classes } = props;
    const { error } = state;

    return (<>
      <Grid item xs={12} className={classes.ssl}>
        <Lock style={{ color: "black" }} fontSize="small"/> <Typography style={{ color: "black" }} variant="body2"><strong>Secured by Stripe.</strong></Typography>
      </Grid>

      <Grid item xs={12}>
        <Element name="element-cc-details">
          <TviTextFiled
            label="Card Number"
            variant="outlined"
            error={error ? true : false}
            required
            fullWidth
            InputProps={{
              inputComponent: StripeInput,
              inputProps: { component: CardNumberElement, onChange: handleChange },
            }}
            InputLabelProps={{ shrink: true }}
          />
        </Element>
      </Grid>

      <Grid item xs={12}>
        <TviTextFiled
          label="Expiry Date"
          variant="outlined"
          error={error ? true : false}
          required
          fullWidth
          InputProps={{
            inputComponent: StripeInput,
            inputProps: { component: CardExpiryElement, onChange: handleChange },
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12}>
        <TviTextFiled
          label="CVC"
          variant="outlined"
          error={error ? true : false}
          required
          fullWidth
          InputProps={{
            inputComponent: StripeInput,
            inputProps: { component: CardCvcElement, onChange: handleChange },
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      {error ? 
        <Grid item xs={12}>
          <Alert severity="error">{error}</Alert> 
        </Grid>
      : null}
    </>);
  }

  renderCheckboxes = () => {
    const { state, props } = this;
    const { agreeOne, agreeTwo, agreeThree } = state;
    const { cart, coupon, installments, rebate, balance, depositUsed, creditUsed } = props;
    const installment = installments.find(({ paid }) => !paid);
    const content = [];
    const [ productTotalStr, customOfferSubsTotalStr, subsTotalStr ] = getTotalPricesStrArray(cart, coupon, installment, rebate, balance, depositUsed, creditUsed);

    if (hasUnPaidProducts(cart)) {
      content.push(
        <FormControlLabel key='0'
          control={<Checkbox color="primary" checked={agreeTwo} onChange={(event) => this.setState({ agreeTwo: event.target.checked })} name="agreeTwo" />}
          label={<Typography variant="body2">I understand that <strong>{productTotalStr.replace(' +', '')}</strong> is a one off payment.</Typography>}
        />
      )
    }
  
    if (hasUnPaidSubscriptions(cart)) {
      let subscriptionPriceStr;
      if (subsTotalStr.length > 0) subscriptionPriceStr = subsTotalStr;
      else if (customOfferSubsTotalStr.length > 0) subscriptionPriceStr = customOfferSubsTotalStr;
  
      content.push(
        <FormControlLabel key='1'
          control={<Checkbox color="primary" checked={agreeThree} onChange={({ target }) => this.setState({ agreeThree: target.checked })} name="agreeThree" />}
          label={<Typography variant="body2">I understand that <strong>{subscriptionPriceStr}</strong> is a recurring payment.</Typography>}
        />
      );
    }

    return (<>
      <Grid item xs={12}>
        <Grid container  direction="column" justify="flex-start" alignItems="stretch">
          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeOne} onChange={({ target }) => this.setState({ agreeOne: target.checked })} name="agreeOne" />}
            label={<Typography variant="body2">I hereby confirm that I have read, understand and agree to be bound by the terms of these documents. 
              <Link href="https://www.tradeview.com.au/legal-documents/terms/" target="_blank">Terms and Conditions</Link>, 
              <Link href="https://www.tradeview.com.au/legal-documents/privacy-policy/" target="_blank">Privacy Policy</Link>, 
              <Link href="https://www.tradeview.com.au/legal-documents/disclaimer/" target="_blank">Disclaimer</Link>, 
              <Link href="https://www.tradeview.com.au/legal-documents/financial-services-guide/?_ga=2.215575826.440151372.1594595168-1439122008.1594595168" target="_blank">Financial Services Guide</Link>
            </Typography>}
          />

          {content}
        </Grid>
      </Grid>
    </>);
  }

  render() {
    const { props, validateCard, renderCardDetailsForm, renderCardLogos, renderCheckboxes } = this;
    const { classes, loading, renderTermsAndConditions, renderCartList, cart, pureBalancePayment } = props;
    
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
        <Elements stripe={stripePromise}>
          <ElementsConsumer>{({ stripe, elements }) => (
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.cardLogoContainer}>{renderCardLogos(pureBalancePayment)}</Grid>

              {!pureBalancePayment && renderCardDetailsForm()}

              {/* <Grid item xs={12}>{renderTermsAndConditions()}</Grid> */}
              <Grid item xs={12}>{renderCartList()}</Grid>
    
              <Grid item xs={12}>{renderCheckboxes()}</Grid>
    
              <Grid item xs={12}>
                <Button id="stripe-pay-button" className={classes.stripePayBtn} disabled={!stripe || loading || cart.length === 0} type="submit" variant="contained" color="primary" fullWidth onClick={() => validateCard(stripe, elements)} >
                  {loading ? <Typography variant="h5"> <CircularProgress size={20} /> Processing Payment...</Typography> : <Typography variant="h5">Pay</Typography>}
                </Button>
              </Grid>
            </Grid>        
          )}</ElementsConsumer>
        </Elements>
        </Grid>
      </Grid>
    );
  }
}


const mapStateToProps = ({ payment, accountReducer, cartReducer }) => ({
  loading: payment.loading,
  step: payment.step,
  userAccount: accountReducer,
  depositUsed: cartReducer.depositUsed,
  creditUsed: cartReducer.creditUsed,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StripeCheckoutForm));